let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cmMrn")).then(() => parcelRequire('2Q4q0'));